import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import CartAdjust from "./CartAdjust";
const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",

		backgroundColor: theme.palette.background.paper,
	},
	inline: {
		display: "inline",
	},
}));

const Error = (props) => {
	const classes = useStyles();
	const state = useSelector((state) => state);
	const AdjustRef = useRef();
	const CartAdjustHandler = () => {
		AdjustRef.current.Open();

		console.log("CartAdjustHandler clicked");
	};
	const handleAdjust = () => {
		AdjustRef.current.Adjust();
	};

	return (
		<>
			{state.order.order.stockError && (
				<>
					<CartAdjust
						ref={AdjustRef}
						error={
							state.order.order.stockError[
								state.order.order.stockError.length - 1
							].error
						}
						handleAdjust={handleAdjust}
					/>
					{state.order.order.isFailed && (
						<List className={classes.root}>
							<Divider />
							<Typography variant="h6" gutterBottom>
								Error
							</Typography>
							{state.order.order.stockError[
								state.order.order.stockError.length - 1
							].error.map((x, index) => {
								return (
									<ListItem alignItems="flex-start">
										<Box color="error.main">
											{index + 1})
											<Typography>
												Product=
												{
													state.order.order.items.find(
														(y) =>
															y.sku === x.sku &&
															y.companyId === x.companyId &&
															y.siteId === x.siteId
													).title
												}
											</Typography>
											<div>
												requestedQuantity=
												{x.requestedQuantity} missinStock={x.missinStock}
											</div>
										</Box>
									</ListItem>
								);
							})}
							<Button
								variant="contained"
								color="secondary"
								onClick={CartAdjustHandler}
							>
								Adjust the Cart
							</Button>

							<Divider fullWidth />
						</List>
					)}
				</>
			)}
		</>
	);
};
export default Error;
